<template>
  <footer class="footer">
    <div class="footer-left">
      ©2021 - {{ currentYear }} By 
      <a href="https://adil.com.cn" target="_blank" rel="noopener noreferrer" class="adil-link">
        Adil    
      </a>
    </div>
    <div class="footer-right">
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" class="beian-link">
        京ICP备20030919号-1
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
.footer {
  display: flex;
  justify-content: center;
  padding: 10px 20px;
  width: 100%;
  background-color: var(--adil-card-bg);
  border-top: 1px solid #e7e7e7;
  align-items: center;
}

.footer-left,
.footer-right {
  font-size: 14px;
  color: #666;
  margin-right: 20px;
}

.adil-link,
.beian-link {
  font-weight: bold;
  color: #666;
  text-decoration: none; /* 取消下划线 */
}

.adil-link:hover,
.beian-link:hover {
  text-decoration: none; /* 悬停时也取消下划线 */
}
</style>